// @ts-check
import {
  Box,
  ChevronDownIcon,
  ChevronUpIcon,
  Link,
  TableCell,
  TableRow,
  Text,
} from '~/design-system';
import { Trans } from '@lingui/macro';
import React from 'react';
import BrandLogo from '../../BrandLogo';

/**
 * Renders the brands rows
 * @param {Object} props
 * @param {Object[]} props.companies - the list of companies to be rendered
 * @param {Object} props.suppliersMap - the mapping between suppliers and partner ids
 * @param {String} props.selectedSupplier - the name of the selected supplier
 * @param {({brandId: string}) => void} props.onSelectBrand - callback when a brand is matched
 * @param {String | undefined} props.companyId - the id of the selected company
 * @param {String | undefined} props.partnerId - the id of the selected partner
 */
export default function Companies({
  companies,
  suppliersMap,
  selectedSupplier,
  onSelectBrand,
  partnerId,
  companyId,
  ...rest
}) {
  return (
    <React.Fragment>
      {companies?.map((company) => {
        const isSelected = companyId === company.brandId;
        return (
          <CompanyTableRow
            key={company.brandId}
            onClick={() => onSelectBrand(company)}
            isSelected={isSelected}
            {...rest}
          >
            <RowBrandSelection isSelected={isSelected} sx={{ width: 50 }} />
            <RowLogo company={company} sx={{ width: 100 }} />
            <RowName company={company} />
            <TableCell sx={{ height: '100px', width: 50 }} {...rest} />
          </CompanyTableRow>
        );
      })}
    </React.Fragment>
  );
}

function CompanyTableRow({ onClick, children, isSelected, ...rest }) {
  return (
    <TableRow
      sx={{
        cursor: 'pointer',
        ':hover': {
          // color: 'primary',
          backgroundColor: isSelected ? 'selected' : 'light',
        },
        backgroundColor: isSelected ? 'selected' : '',
      }}
      onClick={onClick}
      {...rest}
    >
      {children}
    </TableRow>
  );
}

function RowBrandSelection({ isSelected, ...rest }) {
  return (
    <TableCell sx={{ height: '65px', width: '60px' }} {...rest}>
      <input type="checkbox" checked={isSelected} readOnly />
    </TableCell>
  );
}

function RowLogo({ company, ...rest }) {
  return (
    <TableCell sx={{ height: '100px', width: 140 }} {...rest}>
      <BrandLogo brand={company} />
    </TableCell>
  );
}

function RowName({ company, ...rest }) {
  const [showMore, setShowMore] = React.useState(false);
  const street = company?.street;
  const country = company?.country;
  const city = company?.city;
  const postalCode = company?.postalCode;
  const postalCodeAndCity = [postalCode, city].filter(Boolean).join(' ');
  const address = [country, postalCodeAndCity, street]
    .filter(Boolean)
    .join(', ');
  return (
    <TableCell
      sx={{
        height: '65px',
        textAlign: 'left',
      }}
      {...rest}
    >
      <Text variant="default">{company.name}</Text>
      <Text variant="smallest">{address}</Text>
      <Text
        variant="smallest"
        sx={{
          color: 'brand.lightGraphite',
        }}
      >
        {company.email}
      </Text>
      <Box>
        <Link
          onClick={() => {
            setShowMore(!showMore);
            console.log('todo: show more...');
          }}
        >
          {showMore ? <Trans>Show less</Trans> : <Trans>Show more</Trans>}
          {showMore ? <ChevronUpIcon /> : <ChevronDownIcon />}
        </Link>
        {showMore && (
          <Text variant="smallest" sx={{}}>
            Company ID: {company.brandId}
          </Text>
        )}
      </Box>
    </TableCell>
  );
}
